module.exports = __webpack_public_path__ + "img/image-04.45d97124.jpg";